import React, { useEffect, useState } from "react";
import { api, formatCOP, formatDate } from "../../lib/apiClient";

const POS = {
  dentro: ["Dentro del rango", "text-emerald-800 bg-emerald-50 border-emerald-300"],
  arriba: ["Por encima del rango", "text-amber-900 bg-amber-50 border-amber-300"],
  abajo: ["Por debajo del rango", "text-amber-900 bg-amber-50 border-amber-300"],
};

export function BudgetHistory({ caseId, refreshKey }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/cases/${caseId}/budget-history`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [caseId, refreshKey]);
  if (!data?.rows?.length) return null;
  const m = data.market;
  return (
    <div className="mt-4 border border-gray-200 p-4" data-testid="budget-history">
      <p className="text-sm font-medium text-gray-900">Historial de presupuesto</p>
      {m && (
        <p className="text-xs text-gray-600 mt-0.5" data-testid="budget-history-market">
          Frente a {m.n} contrato(s) SECOP · mediana {formatCOP(m.median)} · rango de referencia {formatCOP(m.range.low)} a {formatCOP(m.range.high)}
        </p>
      )}
      <div className="overflow-x-auto mt-3">
        <table className="w-full text-xs">
          <thead>
            <tr className="text-[10px] uppercase tracking-widest text-gray-500 text-left">
              <th className="py-1 pr-3">Borrador</th><th className="py-1 pr-3">Fecha</th>
              <th className="py-1 pr-3 text-right">Presupuesto</th><th className="py-1 pr-3 text-right">vs. mediana</th>
              <th className="py-1 pr-3">Frente al mercado</th><th className="py-1">Diagnóstico</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map((r) => (
              <tr key={r.version} className="border-t border-gray-100" data-testid={`budget-history-row-${r.version}`}>
                <td className="py-1.5 pr-3">v{r.version}{r.is_current && <span className="ml-1 text-primary">(actual)</span>}</td>
                <td className="py-1.5 pr-3 text-gray-600">{formatDate(r.created_at)}</td>
                <td className="py-1.5 pr-3 text-right font-mono">{r.budget_cop ? formatCOP(r.budget_cop) : "—"}</td>
                <td className="py-1.5 pr-3 text-right font-mono">{r.diff_pct == null ? "—" : `${r.diff_pct > 0 ? "+" : ""}${Math.round(r.diff_pct)}%`}</td>
                <td className="py-1.5 pr-3">
                  {r.position ? <span className={`border px-1.5 py-0.5 ${POS[r.position][1]}`}>{POS[r.position][0]}</span> : "—"}
                </td>
                <td className="py-1.5 text-gray-600">{r.diagnosis_versions.length ? r.diagnosis_versions.map((v) => `v${v}`).join(", ") : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
